import { jwtDecode } from "jwt-decode";

export default function decodeToken<T = any>(token: string): T {
  return jwtDecode<T>(token);
}
